export class InstallerAppError extends Error {
  constructor(status) {
    super(status);
  }
}
